export interface ConfirmModalProps {
  open: boolean
  title: string
  description: string
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
}

// Destructive-action pattern, danger-coloured confirm button - never a
// native confirm(). Used for PRD 04's field delete, PRD 07's discard, PRD
// 08's publish.
export function ConfirmModal({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-bg/80">
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        className="flex w-[360px] flex-col gap-3 rounded-control border border-border bg-surface-raised p-6"
      >
        <h2 id="confirm-modal-title" className="text-header font-semibold text-text-primary">
          {title}
        </h2>
        <p className="text-body text-text-secondary">{description}</p>
        <div className="mt-2 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-control border border-border px-4 py-2 text-body font-medium text-text-primary"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded-control bg-danger px-4 py-2 text-body font-medium text-white"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
